import React, { useEffect } from 'react'
import { OptionModel } from '../common/types/OptionModel'
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { getUserNameOptions } from '../store/slices/usernameOptionsSlice';

const useGetUserName = (
    setUserOptions: (options: OptionModel[]) => void,
    setLoadingDataOptions: (loading: boolean) => void,
) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const params: any = {};

    useEffect(() => {
        const fetchUserName = async () => {
          try {
            setLoadingDataOptions(true)
            const resultActions = await dispatch(getUserNameOptions(params));
            if (getUserNameOptions.fulfilled.match(resultActions)) {
              const usersData = resultActions.payload;
              const options: OptionModel[] = usersData.map((item: any) => ({
                value: item.userId,
                label: item.userDesc ? item.userName + " - " + item.userDesc : item.userName + " - "
              }));
              setUserOptions(options);
            } else {
        
            }
          } catch (error) {
           
          } finally {
            setLoadingDataOptions(false)
          }
        }
        fetchUserName();
      }, [dispatch])
}

export default useGetUserName